// extracted by mini-css-extract-plugin
export var sliderRange = "_o9-2";
export var sliderRoot = "_o9-0";
export var sliderThumb = "_o9-3";
export var sliderTrack = "_o9-1";